__turbopack_context__.v({
  "container": "GbeT_q_container",
  "paymentMethodSelect": "GbeT_q_paymentMethodSelect",
  "statementDescriptor": "GbeT_q_statementDescriptor",
  "submitButtonBox": "GbeT_q_submitButtonBox",
});
